import { useStorageState } from 'react-use-storage-state'

export const useToken = () => {
  return useStorageState<null|string>('token', null)
}
